import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes,RouterModule } from '@angular/router';

import { AssessmentsComponent } from './assessments/assessments.component';
import { DashboardComponent } from "./dashboard/dashboard.component";
import { TakeAssessmentComponent } from "./take-assessment/take-assessment.component";
import { TakeAssignmentComponent } from "./take-assignment/take-assignment.component";
import { AuthGuard } from '../login/services/auth-guard.service';
import { AssessmentResultViewComponent } from '../reports/assessment-result-view/assessment-result-view.component';
import { ReportViewerComponent } from 'app/reports/report-viewer/report-viewer.component';
import { TakeAssetExternalComponent } from './take-asset-external/take-asset-external.component';
import { AssetResultViewComponent } from 'app/reports/asset-result-view/asset-result-view.component';

const assessmentRoutes: Routes = [
  {
    path: 'assessments',
    component: AssessmentsComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        children: [
          { path: 'dashboard', component: DashboardComponent },
          { path: 'take-single-assessment/:uid', component: TakeAssessmentComponent },
          { path: 'take-single-asset/:assetId', component: TakeAssetExternalComponent },
          { path: 'take/:id', component: TakeAssignmentComponent },
          { path: ':id/result/:resultId', component: AssessmentResultViewComponent },
          { path: ':id/reports/:reportId/:assignmentId', component: ReportViewerComponent},
          {path: ':id/asset-result/:resultId', component: AssetResultViewComponent },
          { path: '', pathMatch: 'full', redirectTo: 'dashboard' }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(assessmentRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AssessmentsRoutingModule {}


// WEBPACK FOOTER //
// ./src/app/assessments/assessments-routing.module.ts